export const parseQuadrantFullNameToShortName = (quadrant: string) => {
  switch (quadrant) {
    case 'Frontal Izquierdo':
      return 'FI'
    case 'Frontal Derecho':
      return 'FD'
    case 'Basal Izquierdo':
      return 'BI'
    case 'Basal Derecho':
      return 'BD'
    default:
      return quadrant
  }
}

// eslint-disable

interface ITest {
  process_id: number
  process_name: string
  process_description: string
  test_id: number
  domination: string
  test_name: string
  category_name: string
  type_test_id: number
  user_test_id: number
  completed_test: boolean
  betesa_test_id: number | null
  language?: string
  is_follow_up?: boolean
  root_user_test_id?: number | null
  previous_user_test_id?: number | null
  send_date?: string | null
  answer_date?: string | null
  is_retake?: boolean
  oneEvaluatorAnswered?: boolean
}

/* eslint-disable */

export const orderTestsByProcess = (tests: ITest[]) => {
  const testsByProcess = tests.reduce((acc, test) => {
    const {
      process_id,
      process_name,
      process_description,
      test_id,
      test_name,
      category_name,
      type_test_id,
      user_test_id,
      completed_test,
      betesa_test_id,
      domination,
      language,
      is_follow_up,
      root_user_test_id,
      previous_user_test_id,
      send_date,
      answer_date,
      is_retake,
      oneEvaluatorAnswered,
    } = test
    const process = acc.find((process: any) => process.process_id === process_id)
    if (process) {
      process.tests.push({
        process_id,
        test_id,
        test_name,
        category_name,
        type_test_id,
        user_test_id,
        completed_test,
        betesa_test_id: test.betesa_test_id,
        domination,
        process_name,
        language,
        is_follow_up,
        root_user_test_id,
        previous_user_test_id,
        send_date,
        answer_date,
        is_retake,
        oneEvaluatorAnswered,
      })
    } else {
      acc.push({
        process_id,
        process_name,
        process_description,
        tests: [
          {
            process_id,
            test_id,
            test_name,
            category_name,
            type_test_id,
            user_test_id,
            completed_test,
            betesa_test_id: test.betesa_test_id,
            domination,
            process_name,
            language,
            is_follow_up,
            root_user_test_id,
            previous_user_test_id,
            send_date,
            answer_date,
            is_retake,
            oneEvaluatorAnswered,
          },
        ],
      })
    }
    return acc
  }, [] as any)

  return testsByProcess
}
